var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "newIccStyles", attrs: { id: "contentParent" } },
        _vm._l(_vm.contentSectionsGrouped, function (group) {
          return _c(
            "div",
            { key: group.title },
            [
              group.title
                ? _c(
                    "div",
                    { staticClass: "d-flex ml-1 mb-4" },
                    [
                      _c("graphic", {
                        attrs: {
                          displayOnlyTopicIcon: true,
                          additionalClasses: "d-flex",
                          title: group.document,
                          thumbnail: "",
                          width: "24px",
                        },
                      }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "ml-1 mb-3 black--text" }, [
                        _vm._v(_vm._s(group.title)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(group.sections, function (contentSection) {
                return _c("content-section", {
                  key: contentSection.sectionId,
                  attrs: {
                    "is-notes-section-expanded": _vm.isNotesSectionExpanded,
                    contentSection: contentSection,
                    contentModifiers: _vm.contentModifiers,
                    showAllBookmarks: _vm.showAllBookmarks,
                    renderToolbar: _vm.renderToolbar,
                    showNoteControlMenu: _vm.showNoteControlMenu,
                    userBookmarksDefaultSortOrder:
                      _vm.getUserBookmarkSortOrderForContentSection(
                        contentSection
                      ),
                    highlightType: _vm.highlightType,
                    showTitleAsLink: _vm.showTitleAsLink,
                    displayBreadCrumbs: _vm.displayBreadCrumbs,
                    displaySectionSeparated: _vm.displaySectionSeparated,
                  },
                  on: {
                    sectionSortOrderChanged: function ($event) {
                      return _vm.$emit("sectionSortOrderChanged", $event)
                    },
                    "breadcrumb-clicked": _vm.handleBreadcrumbClick,
                  },
                })
              }),
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.registerDialogs
        ? [
            _c("peak-ahead"),
            _vm._v(" "),
            _c("astm-modal"),
            _vm._v(" "),
            _c("note-bookmark-modals"),
            _vm._v(" "),
            _c("premium-tools-access-restriction-modal"),
            _vm._v(" "),
            _c("toolbar-actions-view-mobile"),
            _vm._v(" "),
            _c("access-restricted"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }